<script setup lang="ts">
import PackingListForm from '@/components/features/packingList/PackingListForm.vue'
import { useRouter, RouterLink } from 'vue-router'
import { Icon } from '@iconify/vue'
import Button from 'primevue/button'
import { usePackingListForm, usePackingListDetailsForm } from '@/composables/usePackingListForm'
import { onMounted, ref } from 'vue'

const router = useRouter()
const { values, handleSubmit, setErrors, formType } = usePackingListDetailsForm('edit')
const packingListId = router.currentRoute.value.params.id as string


onMounted(async () => {
})
</script>

<template>
  <div class="flex justify-between items-center mb-10">
    <RouterLink
      to="/packingList"
      class="flex items-center gap-x-2 group hover:text-primary-default"
    >
      <Icon
        icon="material-symbols:arrow-back-rounded"
        class="text-3xl group-hover:translate-x-2 transition-transform"
      />
      <span>Back</span>
    </RouterLink>

    <h1 class="font-semibold text-2xl">Packing List</h1>

      <Button label="Save Changes" @click="() => {}">
        <template #icon>
          <Icon icon="material-symbols:save" class="text-xl ml-3 order-1" />
        </template>
      </Button>
  </div>

  <div class="bg-white rounded-xl pb-2">
    <PackingListForm
      :values="values"
      :type="formType"
      @submit="handleSubmit"
      :setErrors="setErrors"
    />
  </div>
</template>
